import React, { useState, useEffect } from "react";
import { Container, Typography, Button, TextField, Stack, Paper, Alert } from "@mui/material";
import { sendMagicLink, completeMagicLinkSignIn, signInWithGoogle } from "../services/authService";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        navigate("/"); // Nach erfolgreichem Login weiterleiten
      }
    });

    // **Magic Link Anmeldung automatisch aus der URL prüfen**
    completeMagicLinkSignIn().then((result) => {
      if (result?.success) {
        navigate("/"); // Weiterleiten nach erfolgreicher Anmeldung
      } else if (result?.error) {
        setMessage({ type: "error", text: result.error });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleMagicLink = async () => {
    const result = await sendMagicLink(email);
    setMessage(result.success ? { type: "success", text: result.message } : { type: "error", text: result.error });
  };

  const handleGoogleSignIn = async () => {
    await signInWithGoogle();
  };

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 4, mt: 5, textAlign: "center" }}>
        <Typography variant="h4" gutterBottom>Willkommen!</Typography>
        <Typography variant="body1" gutterBottom>Bitte melde dich mit deiner E-Mail an:</Typography>

        {message && <Alert severity={message.type} sx={{ my: 2 }}>{message.text}</Alert>}

        <Stack spacing={2} sx={{ mt: 3 }}>
          <TextField label="E-Mail-Adresse" variant="outlined" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button variant="contained" color="secondary" onClick={handleMagicLink} disabled={!email}>
            Anmelde-Link senden
          </Button>
          <Button variant="contained" color="primary" onClick={handleGoogleSignIn}>
            Mit Google anmelden
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default SignInPage;
